import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const fetchExternalMediaLogsFile = async ({ patientId, trialId, mediaType }) => {
  const token = localStorage.getItem("token");

  const params = new URLSearchParams();
  params.append("patient_id", patientId);
  params.append("trial_id", trialId);

  if (mediaType) {
    params.append("media_type", mediaType);
  }

  const response = await axios.get(
    `${__API_URL__}/api/photos/get_external_media_logs_file/?${params.toString()}`,
    {
      headers: {
        Authorization: `Token ${token}`,
      },
    }
  );

  return response.data;
};

const useGetExternalMediaLogsFile = ({ patientId, trialId, mediaType, enabled = true }) => {
  return useQuery({
    queryKey: ["external_media_logs_file", patientId, trialId, mediaType],
    queryFn: () =>
      fetchExternalMediaLogsFile({
        patientId,
        trialId,
        mediaType,
      }),
    enabled: enabled && Boolean(patientId && trialId),
  });
};

export default useGetExternalMediaLogsFile;
